import { adminAuthenticationImpersonatedUserTokenGetSlice } from './get';

export const {
	requestGetAdminAuthenticationImpersonatedUserToken,
	resetGetAdminAuthenticationImpersonatedUserToken
} = adminAuthenticationImpersonatedUserTokenGetSlice.asyncActionCreators;
